const deviceType = {
  MOBILE: 280,
  MOBILELARGE: 414,
  TABLET: 768,
  LAPTOP: 1024,
  DESKTOP: 1440,
};

export default Object.freeze(deviceType);
